<template>
  <div v-if="view === 'grid'" :class="gridContainerClass">
    <div v-for="n in count" :key="n" class="card-skeleton">
      <Skeleton width="100%" height="190px" class="card-skeleton-image" />
      <div class="p-3">
        <Skeleton width="70%" height="18px" class="mb-2" />
        <Skeleton width="40%" height="14px" class="mb-3" />
        <Skeleton width="90%" height="12px" class="mb-1" />
        <Skeleton width="30%" height="12px" class="mb-2" />
        <Skeleton width="80%" height="12px" />
      </div>
    </div>
  </div>
  <div v-else class="row-cards-skeleton">
    <div v-for="n in count" :key="n" class="row-card-skeleton">
      <div class="row-img">
        <Skeleton width="100%" height="228px" class="row-skeleton-image"/>
      </div>
      <div class="row-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <Skeleton width="60%" height="20px" />
          <Skeleton width="25%" height="20px" />
        </div>
        <Skeleton width="60%" height="16px" class="mb-3" />
        <div class="mb-3 d-flex justify-content-between align-items-center" style="width: 50%;">
          <Skeleton width="40%" height="16px" />
          <Skeleton width="30%" height="16px" />
        </div>
        <div class="mb-4 d-flex justify-content-between align-items-center" style="width: 50%;">
          <Skeleton width="40%" height="16px" />
          <Skeleton width="30%" height="16px" />
        </div>
        <Skeleton width="25%" height="18px" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';
import Skeleton from 'primevue/skeleton';

const props = defineProps({
  count: { type: Number, default: 8 },
  view: { type: String as PropType<'grid' | 'row'>, default: 'grid' },
  gridClass: { type: String, default: '' },
});

const gridContainerClass = computed(() => {
  if (props.view !== 'grid') return 'row-cards-skeleton';
  return props.gridClass ? props.gridClass : 'grid-cards-skeleton';
});
</script>

<style scoped lang="scss">
@import "~/assets/styles/_mixins.scss";

.grid-cards-skeleton {
  display: grid;
  //grid-template-columns: repeat(1, 1fr);
  grid-template-columns: repeat( auto-fill, minmax(100%, 1fr) );
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 24px;
    @include screen-mobile-above-sm {
  //   grid-template-columns: repeat(2, 1fr);
    grid-template-columns: repeat( auto-fill, minmax(33.33%, 1fr) );
    
  }
    @include screen-mobile-above {
   grid-template-columns: repeat( auto-fill, minmax(25%, 1fr) );
   //grid-template-columns: repeat(3, 1fr);   

   grid-column-gap: 16px;
    grid-row-gap: 16px;
  }
    @include screen-laptop-above-xl {
    grid-template-columns: repeat( auto-fit, minmax(25%, 1fr) );
    grid-column-gap: 30px;
    grid-row-gap: 24px;
  }
}

.row-cards-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-skeleton,
.row-card-skeleton {
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  background: #FFF
}

.row-card-skeleton {
  display: flex;
  align-items: stretch;
}

.row-img {
  flex: 0 0 33%;
}

.card-skeleton-image {
  border-radius: 8px 8px 0 0;
}

.row-skeleton-image {
  border-radius: 8px 0 0 8px;
}

.row-body {
  padding: 30px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
